import { useState, useEffect } from "react";
import { mainSiteUrl } from "@/mocks/categories";
import CategoryDropdown from "./CategoryDropdown";

export default function HeroSection() {
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  useEffect(() => {
    if (!showToast) return;
    const timer = setTimeout(() => setShowToast(false), 1200);
    return () => clearTimeout(timer);
  }, [showToast]);

  const handleCategorySelect = (url: string) => {
    window.open(url, "_blank", "noopener,nofollow");
  };

  const handleBuyNow = () => {
    setToastMsg("Redirecting to GTBuy main store...");
    setShowToast(true);
    setTimeout(() => {
      window.open(mainSiteUrl, "_blank", "noopener,nofollow");
    }, 400);
  };

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20fashion%20flatlay%20with%20white%20sneakers%20beige%20hoodie%20leather%20bag%20and%20gold%20accessories%20on%20cream%20textured%20background%20soft%20natural%20daylight%20scandinavian%20aesthetic%20editorial%20product%20photography%20high%20detail%20warm%20neutral%20tones%20organic%20composition%20no%20harsh%20shadows%20elegant%20minimal%20style&width=1600&height=900&seq=gtbuy-hero-main-2026&orientation=landscape"
        alt="GTBuy fashion product showcase"
        title="GTBuy fashion products collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left pt-16 md:pt-20">
            <span className="inline-block bg-accent-500/90 text-background-50 text-xs font-medium px-3 py-1 rounded-full mb-4">
              Smart Shopping Hub
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              GTBuy Sheet
              <br />
              <span className="text-accent-300">Shop Smarter</span>
            </h1>
            <p className="text-background-50/80 text-sm md:text-base max-w-lg mx-auto lg:mx-0 mb-6 leading-relaxed">
              Your ultimate shopping spreadsheet system. Compare products across platforms, 
              track the best deals, and make informed buying decisions with real-time data.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4">
              <CategoryDropdown onSelect={handleCategorySelect} />

              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  GTBuy Sheet
                  <i className="ri-arrow-right-up-line"></i>
                </a>
                <button
                  onClick={handleBuyNow}
                  className="border-2 border-background-50/40 hover:border-background-50/80 text-background-50 px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 bg-transparent"
                >
                  Buy It Now
                  <i className="ri-arrow-right-up-line"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="hidden lg:grid grid-cols-2 gap-3 flex-shrink-0 w-[380px]">
            <div className="col-span-2">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20flatlay%20with%20pair%20of%20white%20minimal%20sneakers%20and%20denim%20fabric%20on%20cream%20paper%20background%20natural%20sunlight%20soft%20pastel%20aesthetic%20editorial%20product%20photography%20clean%20composition%20scandinavian%20design%20warm%20tones%20no%20text&width=800&height=500&seq=gtbuy-hero-grid-1&orientation=landscape"
                alt="Shoes &amp; Fashion"
                title="GTBuy Shoes category"
                className="w-full h-[260px] object-cover object-top rounded-2xl"
              />
            </div>
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20beige%20hoodie%20folded%20neatly%20on%20light%20wooden%20surface%20with%20soft%20shadows%20clean%20aesthetic%20editorial%20style%20product%20photography%20warm%20neutral%20tones%20scandinavian%20minimalism&width=400&height=300&seq=gtbuy-hero-grid-2&orientation=landscape"
              alt="Hoodies &amp; Sweaters"
              title="GTBuy Hoodies category"
              className="w-full h-[140px] object-cover object-top rounded-2xl"
            />
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20leather%20crossbody%20bag%20with%20gold%20chain%20on%20cream%20marble%20surface%20with%20dried%20flowers%20soft%20natural%20lighting%20editorial%20product%20photography%20warm%20aesthetic%20minimal%20luxury%20style%20clean%20composition&width=400&height=300&seq=gtbuy-hero-grid-3&orientation=landscape"
              alt="Bags &amp; Accessories"
              title="GTBuy Bags category"
              className="w-full h-[140px] object-cover object-top rounded-2xl"
            />
          </div>
        </div>
      </div>

      {showToast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-foreground-900 text-background-50 px-5 py-3 rounded-full text-sm shadow-lg animate-pulse">
          {toastMsg}
        </div>
      )}
    </section>
  );
}